import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import JoinPolicyComponent from '@/components/JoinPolicy'

@inject('store')
@observer
export default class JoinPolicyContainer extends Component {
  state = {
    showEcoPolicyHistory: false,
    showWrapsodyPolicyHistory: false
  }

  async componentWillMount() {}

  cancelButton = () => {
    this.props.hideModal()
  }

  handleClickTab = target => {
    if (target === 'tab1') this.props.openTermsService()
    else if (target === 'tab2') this.props.openPrivatePolicy()
    document.querySelector('.modal-body').scroll({ top: 0 })
  }

  showEcoHistoryContent = () => {
    this.setState({
      showEcoPolicyHistory: true
    })
  }

  showWrapsodyHistoryContent = () => {
    this.setState({
      showWrapsodyPolicyHistory: true
    })
  }

  hideEcoHistoryContent = () => {
    this.setState({
      showEcoPolicyHistory: false
    })
  }

  hideWrapsodyHistoryContent = () => {
    this.setState({
      showWrapsodyPolicyHistory: false
    })
  }

  render() {
    const { showPolicy, hideModal, tabTarget } = this.props
    const { showEcoPolicyHistory, showWrapsodyPolicyHistory } = this.state

    return (
      <JoinPolicyComponent
        cancelButton={this.cancelButton.bind(this)}
        hideModal={hideModal}
        showPolicy={showPolicy}
        showEcoPolicyHistory={showEcoPolicyHistory}
        showWrapsodyPolicyHistory={showWrapsodyPolicyHistory}
        tabTarget={tabTarget}
        handleClickTab={this.handleClickTab.bind(this)}
        showEcoHistoryContent={this.showEcoHistoryContent.bind(this)}
        hideEcoHistoryContent={this.hideEcoHistoryContent.bind(this)}
        showWrapsodyHistoryContent={this.showWrapsodyHistoryContent.bind(this)}
        hideWrapsodyHistoryContent={this.hideWrapsodyHistoryContent.bind(this)}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/JoinPolicy/index.js